import React from 'react';
import { Icon } from './Icon.jsx';

// Tones map to the app's tinted action chips (banknote=green, bell=blue, link=neutral).
const TONES = {
  neutral: { bg: 'rgba(148,163,184,0.10)', color: 'var(--text-faint)', on: 'var(--slate-700)' },
  green:   { bg: 'var(--brand-green-soft)', color: 'var(--brand-green)', on: 'var(--brand-green)' },
  blue:    { bg: 'var(--accent-blue-soft)', color: 'var(--accent-blue)', on: 'var(--accent-blue)' },
  red:     { bg: 'var(--status-overdue-bg)', color: 'var(--status-overdue)', on: 'var(--status-overdue)' },
};

const SIZES = { lg: 48, md: 44, sm: 36 };

/**
 * IconButton — square, rounded, tinted action chip (the app's row of
 * banknote / bell / link buttons). `active` fills it solid with white glyph.
 */
export function IconButton({
  icon,
  tone = 'neutral',
  size = 'md',
  active = false,
  disabled = false,
  label,
  style = {},
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const [press, setPress] = React.useState(false);
  const t = TONES[tone] || TONES.neutral;
  const dim = SIZES[size] || SIZES.md;

  const styles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: dim,
    height: dim,
    borderRadius: 'var(--radius)',
    border: 'none',
    background: active ? t.on : t.bg,
    color: active ? '#fff' : t.color,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.4 : 1,
    filter: hover && !disabled ? 'brightness(1.12)' : 'none',
    transform: press && !disabled ? 'scale(0.92)' : 'scale(1)',
    transition: 'transform .1s ease, filter .15s ease, background .15s ease',
    ...style,
  };

  return (
    <button
      style={styles}
      disabled={disabled}
      aria-label={label}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setPress(false); }}
      onMouseDown={() => setPress(true)}
      onMouseUp={() => setPress(false)}
      {...rest}
    >
      <Icon name={icon} size={Math.round(dim * 0.44)} strokeWidth={2.2} />
    </button>
  );
}
